import { Box } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface BusinessPolicyViolationTitleProps {
  messageCode: LangEnum;
  policyName: string;
}

const BusinessPolicyViolationTitle = ({
  messageCode,
  policyName,
}: BusinessPolicyViolationTitleProps) => {
  const { translate } = useTranslation();

  return (
    <>
      {translate(messageCode, {
        expected: (
          <Box component="span" sx={{ fontWeight: 600 }}>
            {policyName}
          </Box>
        ),
      })}
    </>
  );
};

export default BusinessPolicyViolationTitle;
